import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
  jsonLogic: [],
  jsonString: '',
  ruleErrors: {},
  ruleValidationErrors: {},
  isShowRuleValidationError: false,
};

const queryBuilder = createSlice({
  name: 'queryBuilder',
  initialState,
  reducers: {
    setJsonLogic(state, action) {
      state.jsonLogic = action?.payload;
    },

    setIsShowRuleValidationError(state, action) {
      state.isShowRuleValidationError = action?.payload;
    },

    setRuleValidationErrors(state, action) {
      state.ruleValidationErrors = action?.payload;
    },

    setJsonLogicRuleValidationErrors(state, action) {
      state.ruleErrors = action?.payload;
    },
  },
});

export default queryBuilder?.reducer;

export const {
  setJsonLogic,
  setJsonLogicRuleValidationErrors,
  setRuleValidationErrors,
  setIsShowRuleValidationError,
} = queryBuilder?.actions;
